import { Controller } from "@hotwired/stimulus"
import { driver } from "driver.js"

export default class extends Controller {
  static values = {
    steps: Array,
    showProgress: { type: Boolean, default: true },
    showButtons: { type: Array, default: ['next', 'previous', 'close'] },
    popoverClass: String,
    animate: { type: Boolean, default: true },
    smoothScroll: { type: Boolean, default: true }
  }

  connect() {
    this.driverObj = null
    this.initializeDefaultSteps();
    this.start();
  }

  disconnect() {
    if (this.driverObj) {
      this.driverObj.destroy();
    }
  }

  // Initialize default tour steps for the application
  initializeDefaultSteps() {
    if (!this.hasStepsValue) {
      this.stepsValue = [
        {
          element: '#user_menu_dropdown',
          popover: {
            title: 'Osobni izbornik',
            description: 'Ovdje možete pristupiti svom profilu, postavkama, dnevniku lova, oružju, psima i svim osobnim podacima.',
            side: 'bottom',
            align: 'end'
          }
        },
        {
          element: '#navbar-menu a[href*="map"]',
          popover: {
            title: 'Mapa',
            description: 'Interaktivna lovačka mapa s lokacijama, zapažanjima divljači i lovištima. Dodajte svoje lokacije i dijelite ih s ostalim lovcima.',
            side: 'bottom',
            align: 'start'
          }
        },
        {
          element: '#navbar-menu a[href*="marketplace"]',
          popover: {
            title: 'Oglasi',
            description: 'Pregledajte i objavljujte oglase za lovačku opremu, oružje, optiku i sve ostalo što vam treba za uspješan lov.',
            side: 'bottom',
            align: 'start'
          }
        },
        {
          element: '#navbar-menu a[href*="events"]',
          popover: {
            title: 'Događanja',
            description: 'Ovdje su dostupni privatni eventi, društveni događaji, aktivnosti lovačkih grupa i kalendar lovostaja.',
            side: 'bottom',
            align: 'start'
          }
        },
        {
          element: 'a[href*="/forecast"]',
          popover: {
            title: 'Vremenska prognoza',
            description: 'Pregledajte vremensku prognozu za vaše lovište. Napomena: potrebno je dodati lokaciju u postavkama profila.',
            side: 'left',
            align: 'start'
          }
        }
      ]
    }
  }

  // Start a guided tour with the configured steps
  // Creates a new driver instance and begins the tour sequence
  start() {
    let isLastStep = false
    
    const config = {
      showProgress: this.showProgressValue,
      showButtons: this.showButtonsValue,
      animate: this.animateValue,
      smoothScroll: this.smoothScrollValue,
      nextBtnText: 'Sljedeće',
      prevBtnText: 'Prethodno',
      doneBtnText: 'Gotovo',
      onNextClick: () => {
        if (this.driverObj && this.driverObj.isLastStep()) {
          isLastStep = true
        }
        this.driverObj.moveNext()
      },
      onDestroyed: () => {
        if (isLastStep) {
          this.markIntroCompleted()
        }
      }
    }

    if (this.hasPopoverClassValue) {
      config.popoverClass = this.popoverClassValue
    }

    if (this.hasStepsValue && this.stepsValue.length > 0) {
      config.steps = this.stepsValue
    }

    this.driverObj = driver(config)
    this.driverObj.drive()
  }

  // Mark the intro as completed in the database
  markIntroCompleted() {
    fetch('/personal/complete_intro', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    }).catch(error => {
      console.error('Failed to mark intro as completed:', error)
    })
  }

  highlight(event) {
    const element = event.currentTarget.dataset.element || event.currentTarget
    const popover = event.currentTarget.dataset.popover ? JSON.parse(event.currentTarget.dataset.popover) : {}
    
    const config = {
      animate: this.animateValue,
      smoothScroll: this.smoothScrollValue
    }

    this.driverObj = driver(config)
    this.driverObj.highlight({
      element: typeof element === 'string' ? element : element,
      popover: popover
    })
  }

  // Stop and destroy the current driver instance
  // Removes all highlights and popovers from the page
  stop() {
    if (this.driverObj) {
      this.driverObj.destroy()
      this.driverObj = null
    }
  }
}
